import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { gsap } from "gsap";
import "./midGallery.scss";

export default function MidGallery() {
    const containerRef = useRef(null);
    const textRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Fade in on component load
        gsap.to(containerRef.current, { opacity: 1, duration: 1 });

        // Typing effect: reveal one character at a time
        const text = "Come, walk through our catalogue of memories.";
        textRef.current.innerHTML = ""; // Clear initial text
        text.split("").forEach((char, index) => {
            const span = document.createElement("span");
            span.textContent = char;
            span.style.opacity = "0";
            textRef.current.appendChild(span);

            gsap.to(span, {
                opacity: 1,
                delay: index * 0.05, // 50ms delay between characters
                duration: 0.5,
            });
        });

        // Timeline for fade-out and redirect
        const tl = gsap.timeline({
            onComplete: () => navigate("/gallery"),
        });

        tl.to(containerRef.current, { opacity: 1, duration: 1, delay: 2 }) // Hold visibility
            .to(containerRef.current, { opacity: 1, duration: 5 }) // Hold visibility
            .to(containerRef.current, { opacity: 0, duration: 1 }); // Fade-out

        return () => tl.kill();
    }, [navigate]);

    return (
        <div ref={containerRef} className="videoContainer1" style={{ opacity: 0 }}>
            <video className="video-background1" autoPlay loop muted playsInline>
                <source
                    src="https://res.cloudinary.com/dqgtosjsg/video/upload/v1737807447/Untitled_video_-_Made_with_Clipchamp_qjxuo6.mp4"
                    type="video/mp4"
                />
            </video>
            <div className="content-overlay1">
                <p className="content-details1" ref={textRef}></p>
            </div>
        </div>
    );
}

